import { Auth0Client } from "@auth0/auth0-spa-js";
import axios from "axios";
import { getBasicAuthConfig } from "./authUtils";
import { Capability } from "../types/catalog";

export interface Entitlement {
  orgId: string;
  tier: string;
  addOns: string[];
  seats: {
    used: number;
    limit: number;
    purchased?: number;
  };
  isRestricted: boolean;
  rolloutFlags?: Record<string, boolean>;
  capabilities: Record<string, Capability>;
  organization?: {
    id: string;
    name: string;
    auth0OrgId: string;
  };
}

export enum EntitlementAction {
  ADD_MEMBER = "add_member",
  REMOVE_MEMBER = "remove_member",
  ACCESS_FEATURE = "access_feature",
  INITIATE_CHARGE = "initiate_charge",
  MEMBER_MANAGEMENT = "member_management",
  BILLING_ACCESS = "billing_access",
  SUBSCRIPTION_MANAGEMENT = "subscription_management",
}

export class EntitlementsApi {
  private readonly auth0Client: Auth0Client;

  private readonly baseUrl: string;

  constructor(auth0Client: Auth0Client) {
    this.auth0Client = auth0Client;
    this.baseUrl = `${import.meta.env.VITE_PROVIDER_SERVICE_BASE}/organizations`;
  }

  async getEntitlements(orgId: string): Promise<Entitlement> {
    const config = await getBasicAuthConfig(this.auth0Client);
    const response = await axios.get(
      `${this.baseUrl}/${orgId}/entitlements`,
      config,
    );
    return response.data;
  }

  async checkEntitlement(
    orgId: string,
    action: EntitlementAction | string,
    params: {
      userId?: string;
      userRoles?: string[];
      newRoles?: string[];
      featureKey?: string;
    } = {},
  ): Promise<{ can: boolean; reason?: string }> {
    const config = await getBasicAuthConfig(this.auth0Client);
    const response = await axios.post(
      `${this.baseUrl}/${orgId}/entitlements/check`,
      { action, ...params },
      config,
    );
    return response.data;
  }
}

export const createEntitlementsApi = (auth0Client: Auth0Client) =>
  new EntitlementsApi(auth0Client);
